import G2GridReportCdpView from 'views/G2GridReportCdp'

const G2GridReportCdp = () => <G2GridReportCdpView />

export default G2GridReportCdp
